var map = {
	"./ascii.png": 1601,
	"./bot.png": 7886,
	"./bread.png": 8444,
	"./bubble.png": 9784,
	"./health.png": 3673,
	"./instructions.png": 5628,
	"./more.png": 8973,
	"./pineapple.png": 3579,
	"./pixelcard.png": 9877,
	"./toolkit.png": 5850,
	"./wootv.png": 5806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4449;